<template>
    <div>
        <Alert type="warning" class="mb-0">
          <div v-html="$t('LoanOverdueMessage.paymentIsOverdue')"></div>
        </Alert>
    </div>
</template>

<script>
    import Alert from '@shared/components/Alert'

    export default {
    name: 'LoanOverdueMessage',
    components: { Alert }
  }
</script>
